<div class="header">
  <h2 *ngIf="doc" class="doc_title">Документ № {{ doc?.id }}</h2>
  <h2 *ngIf="!doc" class="doc_title">Новый документ перемещения денег</h2>
</div>

<div class="wrapper drop-padding">
  <form [formGroup]="createForm">
    <div class="topForm">
      <mat-form-field appearance="outline">
        <mat-label>Дата</mat-label>
        <input [formControl]="dateFormControl" matInput [matDatepicker]="picker" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <app-bank-selector
        [control]="bankFromFormControl"
        label="Банк отправитель"
      ></app-bank-selector>
      <app-bank-selector [control]="bankToFormControl" label="Банк получатель"></app-bank-selector>
      <mat-form-field appearance="outline">
        <mat-label>Остаток</mat-label>
        <input
          [formControl]="restFormControl"
          matInput
          placeholder="Остаток"
          type="number"
          (input)="restInput($event)"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Забираю</mat-label>
        <input
          [formControl]="valueFormControl"
          matInput
          placeholder="Забираю"
          type="number"
          (input)="valueInput($event)"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Комиссия</mat-label>
        <input
          [formControl]="commissionFormControl"
          matInput
          placeholder="Комиссия"
          type="number"
          (input)="commissionInput($event)"
        />
      </mat-form-field>
      <button class="submit-button" mat-raised-button color="primary" (click)="save()">
        Сохранить
      </button>
    </div>
  </form>
</div>
